import { AfterViewChecked, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-form-sections-nav',
  templateUrl: './form-sections-nav.component.html',
  styleUrls: ['./form-sections-nav.component.scss']
})
export class FormSectionsNavComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() formType!: string;
  private usanFormSectionSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;
  constructor(private responsive: BreakpointObserver, private navigationService: NavigationService) { 
    this.usanFormSectionSubscription = this.navigationService.getUsanFormSectionStatesUpdate().subscribe(
      () => {
        this.updateContentSize();
      });
  }

  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngAfterViewChecked(): void {
    this.updateContentSize();
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
    this.usanFormSectionSubscription.unsubscribe();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  private updateContentSize() {
    const navElement = document.getElementById('form-side-nav');
    const contentElement = document.getElementById('form-side-nav-content');
    if(!navElement || !contentElement) {
      return;
    }

    const navHeight = navElement.offsetHeight;
    contentElement.style.minHeight = `${navHeight}px`;
    window.addEventListener('resize', () => {
      const newHeight = navElement.offsetHeight;
      contentElement.style.minHeight = `${navHeight}px`;
    });
  }
}
